import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <path d="M9.3 3.3C9.7 2.9 10.3 2.9 10.7 3.3C11.1 3.7 11.1 4.3 10.7 4.7L7.4 8 10.7 11.3C11.1 11.7 11.1 12.3 10.7 12.7C10.3 13.1 9.7 13.1 9.3 12.7L5.3 8.7C4.9 8.3 4.9 7.7 5.3 7.3L9.3 3.3Z" />,
  'ArrowLeft',
);
